export default __webpack_public_path__ + "static/vehicle-card-default-photo~JKItFXZF-a2c05619303087f66e0f823d68fd14a7.jpg";